import React from 'react';
import Checked from '../../icons/checked.svg';
import UncheckedFilled from '../../icons/uncheckedfilled.svg';

type AgreementCheckboxProps = {
	id: string;
	label?: string | React.ReactElement | React.ReactElement[];
	checked: boolean;
	labelVariant?: 'small' | 'default';
} & React.InputHTMLAttributes<HTMLInputElement>;

const AgreementCheckbox = React.forwardRef<HTMLInputElement, AgreementCheckboxProps>(({ id, label, checked, labelVariant = 'default', ...props }, ref) => {

	return (
		<div ref={ref} className="flex relative px-2 gap-3 cursor-pointer">
			<input
				id={id}
				type="checkbox"
				className="cursor-pointer opacity-0 z-[1] min-w-6 h-6 m-0"
				data-cy="agreementCheckbox"
				{...props}
			/>
			<img
				className="absolute w-6 h-6 cursor-pointer"
				src={checked ? Checked : UncheckedFilled}
				alt={checked ? 'Checked' : 'Unchecked'}
			/>
			{label && <label htmlFor={id} className={`relative cursor-pointer font-poppins leading-6 tracking-wide text-zinc-300 ${labelVariant === 'default' ? 'text-base' : 'text-sm'}`}>{label}</label>}
		</div>
	);
});

AgreementCheckbox.displayName = 'Agreement Checkbox';

export default AgreementCheckbox;